import HttpRequest from './HttpRequest';

export default class TagService extends HttpRequest {
  static endpoint = 'tags';

  static async getAll() {
    this.endpoint = 'tags';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'tags';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'tags';
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'tags';
    const response = await this.put(id, data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'tags';
    const response = await this.delete(id);
    return response;
  }
}
